import { ICartItem } from "common/types/carts";

export const getCartItemUnitPrice = (cartItem: ICartItem) => {
  return (
    cartItem.custom_unit_price ??
    (cartItem.subscription ? cartItem.subscription_unit_price : cartItem.default_unit_price)
  );
};
